import { getAdminAxiosInstance } from "../../../api/Admin";


export const updateApiSettings = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`ai-setting/update`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const viewApiSettings = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`ai-setting/edit?id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};